import { Stack, Typography } from '@optimus-web/core';
import { Amount } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { CommanderFormProps } from '@mews-commander/form';
import { ServiceOrderNumberInfoRow } from '../PaymentLink/PaymentLinkDetails/ServiceOrderNumberInfoRow';
import { ServiceOrderDatesInfoRow } from '../PaymentLink/PaymentLinkDetails/ServiceOrderDatesInfoRow';
import { BillAmountInfoRow } from '../PaymentLink/PaymentLinkDetails/BillAmountInfoRow';
import { PaymentRequestLinkForm } from './PaymentRequestLinkForm';
import { PaymentRequestAmountInfoRow } from './PaymentRequestLinkDetails/PaymentRequestAmountInfoRow';
import { PaymentRequestReasonInfoRow } from './PaymentRequestLinkDetails/PaymentRequestReasonInfoRow';
import { useGetPaymentRequestDetailSuspense } from './hooks';

interface PaymentRequestLinkDialogContentProps extends CommanderFormProps {
    paymentRequestId: string;
    accountId: string;
    billAmount?: Amount;
}

export const PaymentRequestLinkDialogContent = ({
    paymentRequestId,
    accountId,
    billAmount,
    ...props
}: PaymentRequestLinkDialogContentProps) => {
    const { data } = useGetPaymentRequestDetailSuspense({ paymentRequestId });

    const { serviceOrderId } = data || {};

    return (
        <Stack vertical spacing="200">
            <Typography textStyle="titleMediumStrong" as="div">
                {lt('DetailPlural')}
            </Typography>
            <Stack vertical spacing="200">
                {serviceOrderId ? (
                    <>
                        <ServiceOrderNumberInfoRow serviceOrderId={serviceOrderId} />
                        <ServiceOrderDatesInfoRow serviceOrderId={serviceOrderId} />
                    </>
                ) : null}
                {billAmount ? <BillAmountInfoRow billAmount={billAmount} /> : null}
                <PaymentRequestAmountInfoRow paymentRequestId={paymentRequestId} />
                <PaymentRequestReasonInfoRow paymentRequestId={paymentRequestId} />
            </Stack>
            <PaymentRequestLinkForm {...props} paymentRequestId={paymentRequestId} accountId={accountId} />
        </Stack>
    );
};
